<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        17.1.2022
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Isabelle Kölbl am Kulturzyklus Kontrast FH OST</h3>
      <div class="mb-1 text-body-secondary">17.1.2022</div>
      <p>
        Zum Podcast Kulturzyklus Kontrast FH OST mit Stefan Ribler, Prof. und Dozent.
      </p>
      <p>
        <a
          href="https://open.spotify.com/episode/6VBxdTxkM0gypZ3ppxSMLy?si=9EuQmF5nSGWEQmNjyTkIOQ&dl_branch=1&nd=1&dlsi=d623faa0f8704943"
          target="_blank">
          Ein gelebtes Sexualleben kann Entspannung auf eine ganze Institutionsabteilung bringen
        </a>
      </p>
      <p>
        Isabelle Kölbl spricht in dieser Folge darüber, warum jeder Mensch die Möglichkeit erhalten soll,
        Sexualität zu leben. Beeinträchtigungen sollen kein Hindernis sein, es gibt immer einen Weg. Sie
        selbst arbeitet als Sexualbegleiterin, unterrichtet an diversen Bildungsinstitutionen und hat Sexcare aufgebaut.
        Eine Dienstleistung, die erotische Erlebnisse für Frauen und Männer mit Handicap bietet. Sie hat klare Credos,
        wenn es darum geht, Sexualbegleiter*innen auszubilden, die für Sexcare arbeiten. Die Vorbereitungen einer
        Begegnung sind immer entscheidend: Was ist die Rolle der Institutionen und des Umfelds und was passiert,
        wenn Gefühle ins Spiel kommen?
      </p>
    </div>

    <div class="col-auto h d-lg-block">
      <img src="/../../../content/blog/blog14_1.png" alt="sexcare bild" width="250">
    </div>
  </div>
</div>
